
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer-tools/agent-resources",
      function () {
        return require("private-next-pages/developer-tools/agent-resources.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer-tools/agent-resources"])
      });
    }
  